import * as React from "react";
import { toINR } from "../../../service/numberFormat";
import "../../../../assets/scss/components/toc/fundTransfer/ftPayout/ftInpField.scss";
import { IftinpValidations, IftinpErrorMsgs, IErrorHandler } from "../../../types/components/fundTransfer/ftTypes";
import { ftFormValidate } from "../generic/ftFormValidation";
import { getProperty } from "../../../service/generic/typeHandler";
import { Idevice } from "../../../types/device";
import DeviceContext from "../../../service/indentifyDevice";
export interface IFtInpFieldProps {
	value?: string | number;
	type: string; //number, text
	min?: number;
	max?: number;
	step?: number;
	onChange?: (key: string, val: any) => void;
	onBlur?: (inpVal: any) => void;
	showProxyField: boolean; //proxy for placeholde and the value to show in INR format
	vr: "normal" | "error" | "warn"; //validationReturn
	clsNm?: string;
	ph?: string; //placeholder
	autoFocus: boolean; //auto focus
	name?: string; //form name
	pattern?: string; //pattern allowed to input
	validation?: IftinpValidations;
	regEx?: string;
	error?: IftinpErrorMsgs; //error messages as per the validation
	info?: string; //a message to show after input field
	proxy_inp: "input" | "proxy";
	validateOnChange: boolean;
	prefix?: React.ReactChild; // text/element to show before the input field
	label: string;
	validationEvent?: "change" | "blur" | "focus";
	maxlength?: number;
}

export function FtInpField(props: IFtInpFieldProps) {
	const inputEle = React.useRef<HTMLInputElement>(null);
	const proxyEle = React.useRef<HTMLLabelElement>(null);
	const [inputState, setInputState] = React.useState<any>(props.value);
	const [info, setInfo] = React.useState<any>(props.info || "");
	const RegExPat: RegExp | string = new RegExp(props.regEx || "");
	//type of device tablet/mobile/desktop
	const handleDevice: Idevice = DeviceContext();
	let stateOfField: IErrorHandler = {
		ErrorState: false,
		key: ""
	};
	function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
		setInputState(e.target.value);
		props.onChange && props.onChange(e.target.name, e.target.value);
	}
	function inpValidate(e: React.ChangeEvent<HTMLInputElement>) {
		if (props.validateOnChange) {
			stateOfField = ftFormValidate(e);
			if (stateOfField.key) {
				if (!(props.error && getProperty(props.error, stateOfField.key))) {
					e.target.dataset.error = "false";
				}
				setInfo((props.error && getProperty(props.error, stateOfField.key)) || "");
			} else {
				setInfo(props.info || "");
			}
		}
	}
	React.useEffect(() => {
		setInfo(props.info || "");
	}, [props.info]);

	React.useEffect(() => {
		setInputState(props.value);
	}, [props.value]);

	return (
		<div className="formInpCont">
			<div className="inpLblCont">
				{props.label && <label className="input-label vMid">{props.label}</label>}

				<div className="ftInpFieldDiv ib vMid">
					{props.prefix && <div className="input_prefix">{props.prefix}</div>}
					<input
						type={props.type}
						autoFocus={props.autoFocus}
						autoComplete={"off"}
						min={props.min}
						max={props.max}
						className={` ftInp ftInpField ${props.clsNm} ${props.proxy_inp === "proxy" ? "hide" : ""}`}
						placeholder={props.ph}
						ref={inputEle}
						onBlur={(e) => {
							if (props.proxy_inp === "proxy") {
								inputEle.current?.classList.add("hide");
								proxyEle.current?.classList.remove("hide");
							}
							props.validationEvent === "blur" && inpValidate(e);
						}}
						onChange={(e) => {
							if (!(props.pattern && RegExPat.test(e.target.value))) {
								return;
							} else {
								handleChange(e);
								(!props.validationEvent || props.validationEvent === "change") && inpValidate(e);
							}
						}}
						name={props.name}
						required={true}
						pattern={props.pattern}
						data-error={false}
						data-validation={JSON.stringify(props.validation)}
						value={inputState}
					/>
					{props.showProxyField && (
						<label
							className={`proxyLbl ftInp ${props.clsNm}`}
							ref={proxyEle}
							onClick={() => {
								inputEle.current?.classList.remove("hide");
								inputEle.current?.focus();
								proxyEle.current?.classList.add("hide");
								inputEle.current?.setAttribute("placeholder", "");
							}}
						>
							<span className={"lblPlaceHolder " + (inputState ? "black_clr" : "grey_clr")}>
								{!inputState ? props.ph : toINR(inputState)}
							</span>
						</label>
					)}
				</div>
			</div>
			<p className={`info ${props.name}err ${props.label && handleDevice.isDesktop ? "mgL" : ""} ${info ? "" : "hide"}`} data-error={false}>
				{info}
			</p>
		</div>
	);
}
